import ButtonCard, { IButtonCard } from ".";
import styles from "./styles.module.scss";

interface IButtonCardList {
  buttons: IButtonCard[];
}

const ButtonCardList = ({ buttons }: IButtonCardList) => {
  return (
    <div className={styles.buttonBgImgList}>
      <div className={styles.buttonBgImgList__container}>
        {buttons.map((button) => (
          <ButtonCard {...button} key={button.id} />
        ))}
      </div>
    </div>
  );
};

export default ButtonCardList;
